import {dateTime} from "services/date";
import {Ticket} from "types/Ticket";
import deserializeTicketType from "services/ngage/deserializers/ticket-type";

/**
 * Transform the given ticket by deserializing object properties
 *
 * @internal
 * @param ticket
 */
export default function deserializeTicket(ticket: any): Ticket {
    ticket.type = deserializeTicketType(ticket.type)
    ticket.issued_at = dateTime(ticket.issued_at)
    ticket.valid_at = dateTime(ticket.valid_at)
    ticket.expires_at = dateTime(ticket.expires_at)
    ticket.revoked_at = dateTime(ticket.revoked_at)
    ticket.created_at = dateTime(ticket.created_at)
    ticket.updated_at = dateTime(ticket.updated_at)

    return ticket;
}